import React from 'react';

import {CreateOrEditDivision, DivisionBody, ReferenceListBodySkeleton} from "@/components";
import {ReferenceList} from "@/routes/list/ReferenceList";

export const DivisionList = () => {
    return <ReferenceList
        entity="division"
        Body={DivisionBody}
        BodySkeleton={ReferenceListBodySkeleton}
        EditBody={CreateOrEditDivision}
    />;
};

export default DivisionList;
